import {makeActionCreator} from '../../../core-utilities/redux';
import {APP_MODEL_PREFIX} from '../redux/state';

export const navToEntity = makeActionCreator(APP_MODEL_PREFIX, 'NAV_TO_ENTITY');

/**
 * @typeDef {Object} NavToEntityPayload
 * @property {String} id
 * @property {String} collection
 */



// WEBPACK FOOTER //
// ./src/js/app/model/actions/navigation.js